<h1>{{ allowMultipleActivities ? 'Select activities' : 'Select activity' }}</h1>
<div class="preamble instructions">
  <p *ngIf=allowMultipleActivities>You can notify for multiple activities at a time.</p>
</div>
<form [formGroup]="form" class="form">
  <ol class="questions">
    <li *ngIf="requiresMeasuredDensity">
      <fieldset>
        <legend> <span class="label">Have you measured the density of the vegetation?</span> <abbr title="(required)"
            class="required">*</abbr>
        </legend>
        <ul class="choices">
          <li> <input type="radio" formControlName="hasMeasuredDensity" [value]="true" required="required"
              id="hasMeasuredDensity" />
            <label for="hasMeasuredDensity">Yes</label>
          </li>
          <li> <input type="radio" formControlName="hasMeasuredDensity" [value]="false" required="required"
              id="hasMeasuredDensity" /> <label for="hasMeasuredDensity">No</label> </li>
        </ul>
      </fieldset>
      <div *ngIf="form.controls['hasMeasuredDensity'].value != null">
        <div class="alert alert-info" role="alert" *ngIf="form.controls['hasMeasuredDensity'].value">
          <h2><i class="fa fa-info-circle"></i></h2>
          Please retain evidence of the density measurement for your records.
        </div>
        <div *ngIf="form.hasError('measuredDensityRequiredValidationError')"
          class="alert alert-warning mt-4" role="alert">
          <h2><i class="fa fa-exclamation-triangle"></i></h2>
          Before you can continue with this notification you must measure the density of the vegetation.
        </div>
      </div>
    </li>
    <li *ngIf="!requiresMeasuredDensity || activityData.hasMeasuredDensity">
      <fieldset>
        <legend> <span class="label">Select the {{ allowMultipleActivities ? 'activities' : 'activity' }} you want to notify for</span>
          <abbr title="(required)" class="required">*</abbr>
        </legend>
        <ul class="choices">
          <li *ngFor="let activity of distinctActivities">
            <label for="activity-{{activity.activityCode}}">
              <input *ngIf="allowMultipleActivities" type="checkbox" [formControlName]="'activity-' + activity.activityCode"  id="activity-{{activity.activityCode}}" />
              <input *ngIf="!allowMultipleActivities" type="radio" [value]="activity.activityCode" id="activity-{{activity.activityCode}}" formControlName="activity" />
              {{activity.description}}</label>
          </li>
        </ul>
      </fieldset>
      

      <div class="alert alert-info mt-4" role="alert" *ngIf="showAirstripOrHelipadMessage">
        <h2><i class="fa fa-info-circle"></i></h2>
        Note that an airstrip or helipad is defined under the code as one which complies with either the Civil
        Aviation Safety Authority guidelines or the Royal Flying Doctors service requirements for Queensland.
      </div>
      <div *ngIf="showAgriculturalEfficiencyMessage" class="alert alert-info mt-4" role="alert">
        <h2><i class="fa fa-info-circle"></i></h2>
        An existing cropped area is an area that has been cropped at least three times in the previous ten year
        period.
      </div>
      <div *ngIf="form.hasError('activityRequiredValidationError') && !form.pristine"
        class="alert alert-warning mt-4" role="alert">
        <span class="requiredIcon fa fa-exclamation-triangle"></span>
        You need to select an activity.
      </div>
      <div *ngIf="showActivityValidForNecessaryEnvironmentalClearingError" class="alert alert-warning mt-4" role="alert">
        <h2><i class="fa fa-exclamation-triangle"></i></h2>
        Clearing for channel diversion in a Category B area will require a development approval. If you
        require further information about the development approval process please call 135 VEG (135 834).
      </div>
      <div *ngIf="showFireManagementLinesValidError" class="alert alert-warning mt-4" role="alert">
        <h2><i class="fa fa-exclamation-triangle"></i></h2>
        Clearing for a fire management line that is 10 metres wide or less is exempt. If you wish to clear a fire
        management line that wider than this in a Category B area, you will need to apply for a development approval.
      </div>
    <div *ngIf="activityControl.value == 'SelectiveHarvestingSilviculturalInCypressREs' ||
                activityControl.value == 'SilviculturalTreatmentInHardwoodDomiREs'" class="alert alert-info mt-4">
        Silvicultural treatment is the selective removal of vegetation to reduce the competition and encourage the growth
        and health of remaining trees that have commercial potential for forestry products and is undertaken in a manner
        that retains the full range of plant species, size classes and relative species cover typical of the
        regional ecosystem in accordance with the requirements of the code.
      </div>
      <div *ngIf="showInfrastructureCoastalRulesError" class="alert alert-warning mt-4" role="alert">
        <h2><i class="fa fa-exclamation-triangle"></i></h2>
        Clearing to establish firebreaks is exempt clearing works if the maximum width of clearing is 1 ½ times the height of the tallest 
        vegetation next to the infrastructure or 20 metres whichever is wider. If you wish to clear a firebreak greater than this, 
        you will need to apply for a development approval. If you need further information please contact 135 VEG (135 834).
      </div>
    </li>
  </ol>
  <li class="footer">
    <ul class="actions">
      <li> <input class="qg-btn btn-global-secondary" type="button" (click)="previous()" value="Previous" /> </li>
      <li> <em> <input class="qg-btn btn-primary" type="submit" (click)="next()"
            value="Next" in-progress-text="Saving..." /> </em> </li>
    </ul>
    <ul class="actions">
      <li>
          <a href="#" (click)="cancel()">Cancel</a>
        </li>
    </ul>
  </li>
</form>
